import { render } from "./logout.vue?vue&type=template&id=fe47e390"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"
script.render = render

export default script